import { CODE_GROUP_CREATION_TYPE } from "../../utils/constants";

export const codeGroupActionButton = (
  group,
  clickHandler,
  downloadPermission,
  showLabels = false
) => {
  const compositeStatus = group?.compositeStatus?.toLowerCase();
  const creationType = group?.creationType;
  const isUploadedType = creationType === CODE_GROUP_CREATION_TYPE.PRE_GENERATED;
  const hasMultiFileDownloadEnabled =
    creationType === CODE_GROUP_CREATION_TYPE.SYSTEM_GENERATED;

  const labelMap = {
    view: "View",
    copy: "Copy",
    edit: "Edit",
    export: "Download",
    delete: "Delete",
  };
  const editableStatuses = ["draft", "active", "inactive"];
  const deletableStatuses = ["draft"];
  const exportableStatuses = ["active", "inactive", "generated", "expired"];

  const createAction = (action, icon) => ({
    action,
    icon,
    label: showLabels ? labelMap[action] : undefined,
    onClick: () => clickHandler(action, group),
  });

  const actionButtons = [createAction("view", "visibility")];

  if (editableStatuses.includes(compositeStatus)) {
    actionButtons.push(createAction("edit", "edit"));
  }

  if (
    exportableStatuses.includes(compositeStatus?.toLowerCase()) &&
    downloadPermission &&
    isUploadedType
  ) {
    actionButtons.push(createAction("export", "download"));
  }

  if (
    exportableStatuses.includes(compositeStatus?.toLowerCase()) &&
    downloadPermission &&
    hasMultiFileDownloadEnabled
  ) {
    actionButtons.push(createAction("export", "download"));
  }

  actionButtons.push(createAction("copy", "content_copy"));

  if (deletableStatuses.includes(compositeStatus)) {
    actionButtons.push(createAction("delete", "delete"));
  }

  return actionButtons;
};
